/* eslint-disable */
<template>
	<section>
		<div class="smaller-heading">Persönliche Angaben</div>
		<div class="text">
			<p></p>
			<p>Sie erhalten per E-Mail und SMS den Schlüsselcode für Ihr Zimmer.</p>
		</div>
		<div class="input_wrapper">
			<div class="columns">
				<div class="column is-half">
					<input class="input" type="text" v-model="firstname" placeholder="Vorname">
				</div>
				<div class="column is-half">
					<input class="input" type="text" v-model="lastname" placeholder="Nachname">
				</div>
			</div>
			<div class="columns">
				<div class="column is-half">
					<input class="input" type="text" v-model="email" placeholder="E-Mail Adresse">
				</div>
				<div class="column is-half">
					<input class="input" type="text" v-model="phone" placeholder="Mobiltelefon">
				</div>
			</div>
		</div>
		<div class="button_wrapper">
			<router-link :to="{ name: 'summary'}">
				<button class="button">Weiter</button>
			</router-link>
		</div>
	</section>
</template>
<script>
import axios from 'axios'

export default {
	name: 'Details',

	components: {
	},
	computed: {
		firstname: {
			get () {
				return this.$store.state.booking.firstname
			},
			set (value) {
				this.$store.commit('firstnameUpdate', value)
			}
		},
		lastname: {
			get () {
				return this.$store.state.booking.lastname
			},
			set (value) {
				this.$store.commit('lastnameUpdate', value)
			}
		},
		email: {
			get () {
				return this.$store.state.booking.email
			},
			set (value) {
				this.$store.commit('emailUpdate', value)
			}
		},
		phone: {
			get () {
				return this.$store.state.booking.phone
			},
			set (value) {
				this.$store.commit('phoneUpdate', value)
			}
		}

	},
	data () {
		return {
		}
	},

	created () {
		// this.fetchData();
	},

	methods: {

	}
}
</script>
<style>

.smaller-heading {
  margin-top:1em;
}
.input_wrapper {
  width:70%;
  margin:0 auto;

}
.input_wrapper input {
  background:transparent;
  font-size: 2em;
  border:0;
  border-bottom: 2px solid black;
  box-shadow: none;
  border-radius: 0;
}
.button_wrapper {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue